import { coreLeftView } from '@/components/core-left-view';
import { useAuth } from '@/contexts/AuthContext';
import { FeedbackWidget } from '@sentry/react-native';
import * as ImagePicker from 'expo-image-picker';
import { Stack, router } from 'expo-router';
import Head from 'expo-router/head';
import { Fragment } from 'react';
import { Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function Feedback() {
  const { user } = useAuth();

  return (
    <Fragment>
      <Head>
        <title>Feedback - Lexikon AI</title>
      </Head>

      <Stack.Screen
        options={{
          headerShown: true,
          title: 'Feedback',
          headerLargeTitle: true,
          headerStyle: { backgroundColor: '#0f1313' },
          headerLeft: coreLeftView
        }}
      />

      <SafeAreaView className="flex-1 pt-10">
        <FeedbackWidget
          showBranding={false}
          imagePicker={ImagePicker as any}
          showName={!user}
          showEmail={!user}
          onFormClose={() => router.navigate('/app')}
          onFormSubmitted={() => router.navigate('/app')}
          messageLabel="Write your feedback"
          messagePlaceholder=""
          emailPlaceholder=""
          namePlaceholder=""
          formTitle=""
          submitButtonLabel="Send Feedback"
          successMessageText="Thank you for your feedback!"
          useSentryUser={
            user
              ? {
                  email: user.email,
                  name: user.name
                }
              : undefined
          }
          styles={{
            label: {
              color: '#fff',
              marginBottom: 8
            },
            input: {
              borderColor: '#353F3D',
              borderWidth: 1,
              borderRadius: 8,
              marginBottom: 16
            },
            textArea: {
              color: '#fff',
              padding: 16,
              borderColor: '#353F3D',
              borderWidth: 1,
              borderRadius: 8,
              marginBottom: 16
            },
            container: {
              backgroundColor: '#00',
              padding: 16
            },
            screenshotButton: {
              backgroundColor: '#E8FDFA',
              borderRadius: 8,
              padding: 12,
              marginBottom: 16,
              alignSelf: 'center',
              width: Platform.OS === 'web' ? '50%' : '100%'
            },
            screenshotText: {
              color: '#000',
              width: '100%',
              fontSize: 18,
              textAlign: 'center'
            },
            screenshotContainer: {
              borderRadius: 8
            },
            screenshotThumbnail: {
              borderRadius: 8,
              height: 100,
              resizeMode: 'contain',
              marginBottom: 8
            },
            submitButton: {
              backgroundColor: '#4BECD9',
              borderRadius: 8,
              padding: 12,
              marginBottom: 16,
              alignSelf: 'center',
              width: Platform.OS === 'web' ? '50%' : '100%'
            },
            submitText: {
              color: '#000',
              width: '100%',
              fontSize: 18,
              textAlign: 'center'
            },
            cancelButton: {
              backgroundColor: '#000',
              borderRadius: 8,
              padding: 12,
              marginTop: 8,
              alignSelf: 'center',
              width: Platform.OS === 'web' ? '50%' : '100%'
            },
            cancelText: {
              color: '#fff',
              width: '100%',
              fontSize: 16,
              textAlign: 'center'
            }
          }}
        />
      </SafeAreaView>
    </Fragment>
  );
}
